






























import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetHospitalizationSummaryList } from "@/api/pdQualityControlManage/pdHospitalizationSummary";
@Component({})
export default class PdHospitalizationSummary extends AbpBase {
  loading: boolean = false;
  HospitalizationSummaryList: any[] = [];
  time: any = new Date();
  HospitalizationSummarycolumns = [
    {
      title: "入院原因",
      key: "inReason",
      minWidth: 200
    },
    {
      title: "总人数",
      key: "zrs",
      minWidth: 160
    },
    {
      title: "治愈",
      key: "zy",
      minWidth: 160
    },
    {
      title: "好转",
      key: "hz",
      minWidth: 160
    },
    {
      title: "无效",
      key: "wx",
      minWidth: 160
    },
    {
      title: "死亡",
      key: "sw",
      minWidth: 160
    },
    {
      title: "转他院",
      key: "zty",
      minWidth: 160
    },
    {
      title: "放弃治疗",
      key: "fqzl",
      minWidth: 160
    },
    {
      title: "其他",
      key: "qt",
      minWidth: 160
    }
  ];
  async getData() {
    this.loading = true;
    var res = await GetHospitalizationSummaryList(this.fmtDate(this.time, "yyyyMM"))
        this.HospitalizationSummaryList = res.objects;
    this.loading = false;
  }
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/pdHospitalizationSummary/index.vue